type Translate = (
    key: string,
    interpolationValues?: Record<string, string | number>,
) => string;

const TIME = {
    MILLISECONDS_PER_SECOND: 1000,
    SECONDS_PER_MINUTE: 60,
    SECONDS_PER_HOUR: 3600,
    SECONDS_PER_DAY: 86400,
    SECONDS_PER_WEEK: 604800,
    SECONDS_PER_MONTH: 2419200,
    SECONDS_PER_YEAR: 29030400,
};

function toEpochMillis(timestamp: number | string): number {
    if (typeof timestamp === 'number') {
        return timestamp;
    }

    const parsed = Date.parse(timestamp);
    return Number.isNaN(parsed) ? Number(timestamp) : parsed;
}

/**
 * Same buckets as `$rootScope.formatDateToSimpleString` in application-controller.js.
 */
function formatDateToSimpleString(timestamp: number | string, t: Translate): string {
    const currentTimestamp = Date.now();
    const diff = (currentTimestamp - toEpochMillis(timestamp)) / TIME.MILLISECONDS_PER_SECOND;
    let diffCount: number;

    if (diff < TIME.SECONDS_PER_MINUTE) {
        return t('ACTIVITY.FEW_SECONDS');
    } else if (diff < TIME.SECONDS_PER_HOUR) {
        diffCount = Math.floor(diff / TIME.SECONDS_PER_MINUTE);
        return (diffCount === 1)
            ? t('ACTIVITY.MINUTE_AGO')
            : t('ACTIVITY.MINUTES_AGO', { count: diffCount });
    } else if (diff < TIME.SECONDS_PER_DAY) {
        diffCount = Math.floor(diff / TIME.SECONDS_PER_HOUR);
        return (diffCount === 1)
            ? t('ACTIVITY.HOUR_AGO')
            : t('ACTIVITY.HOURS_AGO', { count: diffCount });
    } else if (diff < TIME.SECONDS_PER_WEEK) {
        diffCount = Math.floor(diff / TIME.SECONDS_PER_DAY);
        return (diffCount === 1)
            ? t('ACTIVITY.DAY_AGO')
            : t('ACTIVITY.DAYS_AGO', { count: diffCount });
    } else if (diff < TIME.SECONDS_PER_MONTH) {
        diffCount = Math.floor(diff / TIME.SECONDS_PER_WEEK);
        return (diffCount === 1)
            ? t('ACTIVITY.WEEK_AGO')
            : t('ACTIVITY.WEEKS_AGO', { count: diffCount });
    } else if (diff < TIME.SECONDS_PER_YEAR) {
        diffCount = Math.floor(diff / TIME.SECONDS_PER_MONTH);
        return (diffCount === 1)
            ? t('ACTIVITY.MONTH_AGO')
            : t('ACTIVITY.MONTHS_AGO', { count: diffCount });
    }

    diffCount = Math.floor(diff / TIME.SECONDS_PER_YEAR);
    return (diffCount === 1)
        ? t('ACTIVITY.YEAR_AGO')
        : t('ACTIVITY.YEARS_AGO', { count: diffCount });
}

export { formatDateToSimpleString };
